// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { IPermissions } from "@/types/keycloak";
/** What the Settings screen shows someone. */
export var ESettingsAccess;
(function (ESettingsAccess) {
    ESettingsAccess["NONE"] = "none";
    /** Every tab but Logs. */
    ESettingsAccess["CONFIGURATION"] = "configuration";
    /** Only the Logs tab. */
    ESettingsAccess["LOGS"] = "logs";
    ESettingsAccess["CONFIGURATION_AND_LOGS"] = "configuration-and-logs";
})(ESettingsAccess || (ESettingsAccess = {}));
/**
 * Settings opens with settings-menu; its configuration tabs need tenant-write
 * and its Logs tab tenant-logs-read. Both are decided before anything shows.
 */
export var settingsAccess = function (has) {
    if (!has(IPermissions.SETTINGS_MENU))
        return ESettingsAccess.NONE;
    var configuration = has(IPermissions.TENANT_WRITE);
    var logs = has(IPermissions.TENANT_LOGS_READ);
    if (configuration && logs)
        return ESettingsAccess.CONFIGURATION_AND_LOGS;
    if (configuration)
        return ESettingsAccess.CONFIGURATION;
    return logs ? ESettingsAccess.LOGS : ESettingsAccess.NONE;
};
export var showsConfiguration = function (access) {
    return access === ESettingsAccess.CONFIGURATION || access === ESettingsAccess.CONFIGURATION_AND_LOGS;
};
export var showsLogs = function (access) {
    return access === ESettingsAccess.LOGS || access === ESettingsAccess.CONFIGURATION_AND_LOGS;
};
